import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../Utilities/Api";

class serverLibraryCatalogApi {
    static getVendors(systemType: string | number) {
        return sendRequest(
            requestOptions(config.URL + `vendors/system/${systemType}`,
                requestTypes.GET,
            ),
        );
    }

    static getManufacturers() {
        return sendRequest(
            requestOptions(config.URL + `manufacturers`,
                requestTypes.GET,
            ),
        );
    }

    static getVendorsAll() {
        return sendRequest(
            requestOptions(config.URL + `vendors`,
                requestTypes.GET,
            ),
        );
    }

    static saveVendor(vendor: Record<string, unknown>) {
        const requestType = vendor.vendorId ? requestTypes.PUT : requestTypes.POST;
        const requestMessage = vendor.vendorId
            ? apiConstants.successMessage.catalog.CATALOG_VENDOR_UPDATED
            : apiConstants.successMessage.catalog.CATALOG_VENDOR_ADDED;
        return sendRequest(
            requestOptions(config.URL + `vendors`, requestType, JSON.stringify(vendor), requestMessage),
        );
    }

    static getCopyBarcode(catalogCopyId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/inventory/${catalogCopyId}`,
                requestTypes.GET,
            ),
        );
    }
}

export const libraryCatalogApi = config.environment.MODE === config.modes.SERVER ? serverLibraryCatalogApi : serverLibraryCatalogApi;
